"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendTestEmailModal = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const polaris_1 = require("@shopify/polaris");
const styled_components_1 = __importDefault(require("styled-components"));
const nice_modal_react_1 = __importStar(require("@ebay/nice-modal-react"));
const context_1 = require("@/common/context");
const AccountContext_1 = require("contexts/AccountContext");
const send_test_email_modal_graphql_1 = require("./send-test-email-modal.graphql");
const helpers_1 = require("@/common/helpers");
const StyledTextFieldWrapper = styled_components_1.default.span `
    label {
        color: #000;
    }

    input {
        color: var(--p-color-text-secondary);
    }
`;
exports.SendTestEmailModal = nice_modal_react_1.default.create(({ template }) => {
    const modal = (0, nice_modal_react_1.useModal)();
    const { currentUser } = (0, context_1.useCurrentUser)();
    const { account } = (0, AccountContext_1.useAccount)();
    const [modalResponse, setModalResponse] = (0, react_1.useState)(null);
    const handleModalClose = (0, react_1.useCallback)(() => {
        modal.remove();
    }, []);
    (0, react_1.useEffect)(() => {
        if (modalResponse) {
            modalResponse.success
                ? modal.resolve(modalResponse)
                : modal.reject(new Error(modalResponse.message));
            handleModalClose();
        }
    }, [modalResponse]);
    const [sendTestEmail, { loading: sendTestEmailLoading }] = (0, client_1.useMutation)(send_test_email_modal_graphql_1.SEND_TEST_EMAIL, {
        errorPolicy: 'all',
        onCompleted: () => {
            setModalResponse({
                success: true,
                message: `Successfully sent a test email to ${currentUser === null || currentUser === void 0 ? void 0 : currentUser.email}`
            });
        },
        onError(error) {
            const errors = (0, helpers_1.formatGraphqlErrors)(error);
            setModalResponse({
                success: false,
                message: `There was an issue when attempting to send a test email to ${currentUser === null || currentUser === void 0 ? void 0 : currentUser.email}`,
                errorDetails: errors
            });
        }
    });
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if ((account === null || account === void 0 ? void 0 : account.id) && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) && template) {
            yield sendTestEmail({
                variables: {
                    input: {
                        accountId: account.id,
                        notificationTypeSlug: template,
                        userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.id
                    }
                }
            });
        }
    }), []);
    if (!modal.visible) {
        return null;
    }
    return (react_1.default.createElement(polaris_1.Modal, { onClose: handleModalClose, open: modal.visible, primaryAction: {
            content: 'Send',
            onAction: handleSubmit,
            loading: sendTestEmailLoading,
            id: 'send-test-email-send-button'
        }, secondaryActions: [
            {
                content: 'Cancel',
                onAction: handleModalClose,
                id: 'send-test-email-cancel-button'
            }
        ], title: 'Send test email' },
        react_1.default.createElement(polaris_1.Modal.Section, null,
            react_1.default.createElement(StyledTextFieldWrapper, null,
                react_1.default.createElement(polaris_1.TextField, { autoComplete: 'false', autoFocus: false, disabled: true, id: 'send-test-email-to-address-field', label: 'Email', readonly: true, type: 'email', value: currentUser === null || currentUser === void 0 ? void 0 : currentUser.email })))));
});
